import React from 'react'
import { useTranslation } from 'react-i18next';
import { MdOutlinePhone } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";


const ContactInfo = () => {
    const { t } = useTranslation();

  return (
    <div className='container mx-auto py-5 md:py-16 p-6'>
        <h1 className='text-center text-3xl md:text-4xl font-semibold font-Merriweather'>{t('artistrySpawellness')}</h1>
        <h1 className='text-2xl md:text-3xl font-Merriweather border-b py-3 mt-7'>{t('contact')}</h1>
        <div className="flex  md:flex-row flex-col justify-start mt-5 md:mt-10 gap-20">
            {/* <div className='md:w-2/4'>
            <h2 className="text-2xl mb-5 font-Merriweather font-medium">{t('sendMessage')}</h2>
            <input type="text" className='block p-3 border text-black placeholder:text-black w-full mt-5 border-gray-200 ' placeholder={t('name')}/>
            <input type="email" className='block p-3 border text-black placeholder:text-black w-full mt-5 border-gray-200 ' placeholder={t('email')} />
            <input type="text" className='block p-3 border text-black placeholder:text-black w-full mt-5 border-gray-200 ' placeholder={t('phone')} />
            <textarea className='block p-3 h-36 border text-black placeholder:text-black w-full mt-5 border-gray-200 ' placeholder={t('message')} ></textarea>
            <button className="mt-5 w-full p-3 bg-gray-900 text-white uppercase tracking-widest font-semibold font-Merriweather">{t('submit')}</button>
            </div> */}

        <div className='md:text-start text-center' data-aos='fade-left'>
              <h1 className='text-3xl mb-6 font-Merriweather font-light'>{t('artistrySpawellness')}</h1>
               <p className=' mt-2 md:justify-normal justify-center flex gap-2'><MdOutlinePhone className='text-lg'/> <a href="tel: 267-593-1205"> 267-593-1205</a></p>
               <p className='md:justify-normal justify-center text-sm mt-2 flex gap-2'><MdOutlineEmail className='text-lg'/> <a href="mailto: artistryspanwellness@gmail.com">artistryspanwellness@gmail.com</a></p>
               <p className='md:justify-normal justify-center text-sm mt-2 flex gap-2'><IoLocationOutline className='text-lg'/> 227 W Thompson St, Philadelphia, PA 19122</p>

            <div className='mt-10'>
             {/* <h1 className='text-2xl'>{t('hours')}</h1>
             <p className="flex items-center mt-5 text-sm gap-4 tracking-wider p-2 shadow justify-between rounded-md" onClick={() => setIsOpen(!isOpen)}>09:30 am - 09:30 pm<IoIosArrowDown 
                className={`${isOpen ? 'rotate-180' : 'rotate-0'} transition-transform duration-300`} /></p>

            <div className={isOpen ? 'block' : 'hidden'}>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Mon <span>09:30 am - 09:30 pm </span></p>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Tue <span>09:30 am - 09:30 pm</span></p>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Wed <span>09:30 am - 09:30 pm</span></p>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Thu <span>09:30 am - 09:30 pm</span></p>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Fri <span>09:30 am - 09:30 pm</span></p>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Sat <span>09:30 am - 09:30 pm</span></p>
            <p className="mt-2 p-1.5 shadow rounded-md text-sm">Sun <span>09:30 am - 09:30 pm</span></p>
          </div> */}

           <p className="mt-2 p-2 shadow rounded-md text-sm">{t('timingIs')}  Mon-Sun <span>10:30am - 9:00pm </span></p>
            <p className="mt-4 ">{t('openWeek')}</p>
            <p className="mt-2 ">{t('appointmentsEncouraged')}</p>
            </div>
        </div>
        </div>
    </div>
  )
}

export default ContactInfo
